'use client';

import { LinkInternal } from '@sushiswap/ui';
import { useSearchParams } from 'next/navigation';
import { PathnameButton } from 'src/ui/pathname-button';
import { ChainId, ChainKey } from 'sushi/chain';
export function NavigationItems({
  chainId
}: {
  chainId: ChainId;
}) {
  const searchParams = useSearchParams();
  return <>
      <LinkInternal shallow={true} scroll={false} href={`/${ChainKey[chainId]}/pool?${searchParams.toString()}`} data-sentry-element="LinkInternal" data-sentry-source-file="navigation-items.tsx">
        <PathnameButton id="my-positions" pathname={`/${ChainKey[chainId]}/pool`} asChild size="sm" data-sentry-element="PathnameButton" data-sentry-source-file="navigation-items.tsx">
          My Positions
        </PathnameButton>
      </LinkInternal>
      <LinkInternal shallow={true} scroll={false} href={`/${ChainKey[chainId]}/rewards?${searchParams.toString()}`} data-sentry-element="LinkInternal" data-sentry-source-file="navigation-items.tsx">
        <PathnameButton id="my-rewards" pathname={`/${ChainKey[chainId]}/rewards`} asChild size="sm" data-sentry-element="PathnameButton" data-sentry-source-file="navigation-items.tsx">
          My Rewards
        </PathnameButton>
      </LinkInternal>
      <LinkInternal shallow={true} scroll={false} href={`/${ChainKey[chainId]}/migrate?${searchParams.toString()}`} data-sentry-element="LinkInternal" data-sentry-source-file="navigation-items.tsx">
        <PathnameButton id="migrate" pathname={`/${ChainKey[chainId]}/migrate`} asChild size="sm" data-sentry-element="PathnameButton" data-sentry-source-file="navigation-items.tsx">
          Migrate
        </PathnameButton>
      </LinkInternal>
    </>;
}